import script from "./OrdersProformaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersProformaSection.vue?vue&type=script&setup=true&lang=js"

import "./OrdersProformaSection.vue?vue&type=style&index=0&id=001012a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001012a9"]])

export default __exports__